function ProductMaterialsPage() {
    return <>ProductMaterialsPage</>
}

export default ProductMaterialsPage;